var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuiltIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 72,
    viewBox: "0 0 69 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 70.2467C53.0015 70.2467 68 55.2472 68 36.7444C68 18.2417 53.0015 3.24219 34.5 3.24219C15.9985 3.24219 1 18.2417 1 36.7444C1 55.2472 15.9985 70.2467 34.5 70.2467Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2982 16.2129C27.2982 16.2129 26.3889 21.5134 20.9332 22.5903C20.9332 22.5903 16.3748 23.4757 13.8145 18.8452C13.8145 18.8452 20.5982 23.1526 27.2982 16.2129Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7422 31.4806C13.7422 31.4806 15.6924 24.4451 23.194 23.7392C23.194 23.7392 29.4752 23.1649 32.2988 29.7577C32.2988 29.7577 23.7324 23.0213 13.7422 31.4806Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7617 16.2129C41.7617 16.2129 42.671 21.5134 48.1267 22.5903C48.1267 22.5903 52.6851 23.4757 55.2455 18.8452C55.2455 18.8452 48.4617 23.1526 41.7617 16.2129Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2461 31.4806C55.2461 31.4806 53.2959 24.4451 45.7943 23.7392C45.7943 23.7392 39.513 23.1649 36.6895 29.7577C36.6895 29.7577 45.2559 23.0213 55.2461 31.4806Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0145 46.7693C27.0849 46.7693 30.3845 42.2267 30.3845 36.623C30.3845 31.0193 27.0849 26.4766 23.0145 26.4766C18.9442 26.4766 15.6445 31.0193 15.6445 36.623C15.6445 42.2267 18.9442 46.7693 23.0145 46.7693Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2475 44.3515C26.2827 44.3515 27.9325 42.0801 27.9325 39.2783C27.9325 36.4764 26.2827 34.2051 24.2475 34.2051C22.2123 34.2051 20.5625 36.4764 20.5625 39.2783C20.5625 42.0801 22.2123 44.3515 24.2475 44.3515Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9735 46.7693C50.0439 46.7693 53.3435 42.2267 53.3435 36.623C53.3435 31.0193 50.0439 26.4766 45.9735 26.4766C41.9032 26.4766 38.6035 31.0193 38.6035 36.623C38.6035 42.2267 41.9032 46.7693 45.9735 46.7693Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1928 44.3515C49.228 44.3515 50.8778 42.0801 50.8778 39.2783C50.8778 36.4764 49.228 34.2051 47.1928 34.2051C45.1576 34.2051 43.5078 36.4764 43.5078 39.2783C43.5078 42.0801 45.1576 44.3515 47.1928 44.3515Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4338 51.1979C62.8037 51.1979 65.5356 49.2158 65.5356 46.7708C65.5356 44.3258 62.8037 42.3438 59.4338 42.3438C56.0639 42.3438 53.332 44.3258 53.332 46.7708C53.332 49.2158 56.0639 51.1979 59.4338 51.1979Z",
    fill: "#F01F29"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55492 51.1979C12.9248 51.1979 15.6567 49.2158 15.6567 46.7708C15.6567 44.3258 12.9248 42.3438 9.55492 42.3438C6.18499 42.3438 3.45312 44.3258 3.45312 46.7708C3.45312 49.2158 6.18499 51.1979 9.55492 51.1979Z",
    fill: "#F01F29"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2461 58.7015C24.2461 58.7015 33.9491 50.649 45.9732 55.6385L24.2461 58.7015Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2461 58.7015C24.2461 58.7015 33.9491 50.649 45.9732 55.6385",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4782 10.0273C63.4782 10.0273 54.3734 25.1751 63.4782 25.1751C72.5831 25.1751 63.4782 10.0273 63.4782 10.0273Z",
    fill: "#00ADEB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8786 0C50.8786 0 41.7738 15.1478 50.8786 15.1478C59.9834 15.1478 50.8786 0 50.8786 0Z",
    fill: "#00ADEB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuiltIcon);
export default __webpack_public_path__ + "static/media/guilt-icon.fb09239b03845b9691fbe4a2ba7d5c41.svg";
export { ForwardRef as ReactComponent };